import { useMemo, useRef } from 'react'

export const useCurrentRef = (state: (...arg: any[]) => any) => {
  const stateRef = useRef(state)

  useMemo(() => (stateRef.current = state), [state])

  return stateRef
}
